module.exports = __webpack_public_path__ + "img/rights-person_banner.8c96cea9.png";